module.exports = __webpack_public_path__ + "img/H2.46b73b4a.png";